import { LikeEntity, LikeEntityEntityTypeEnum, LikeListResponse, PhotoEntity } from '@interpals/api-web';
import { createAsyncThunk } from '@reduxjs/toolkit';

import api from 'api';

export interface LikeParams {
    entity_type: LikeEntityEntityTypeEnum;
    entity_id: string;
    key?: string;
    photo?: PhotoEntity;
    nested_comment_parent_id?: string;
}

export type DeleteLikeParams = LikeParams & {
    userId: string;
};

interface CreateCommentLikeResponse {
    like: LikeEntity;
    key?: string;
}

export const LIKES_FETCH_LIMIT = 10;

export const createCommentLike = createAsyncThunk<CreateCommentLikeResponse, LikeParams>(
    'create/comment-like',
    async ({ entity_type, entity_id, key }) => {
        const response = await api.createLike({ entity_type, entity_id });

        return { like: response, key };
    },
);

export const deleteCommentLike = createAsyncThunk<{ key: string | undefined; entity_id: string }, LikeParams>(
    'delete/comment-like',
    async ({ entity_type, entity_id, key }) => {
        await api.deleteLike({ entity_type, entity_id });

        return { entity_id, key };
    },
);

export const createLike = createAsyncThunk<LikeEntity, LikeParams>(
    'likes/create',
    async ({ entity_type, entity_id }) => {
        return await api.createLike({ entity_type, entity_id });
    },
);

export const deleteLike = createAsyncThunk<string, DeleteLikeParams>(
    'likes/delete',
    async ({ entity_type, entity_id }) => {
        await api.deleteLike({ entity_type, entity_id: entity_id });

        return entity_id;
    },
);

export const getPhotoLikes = createAsyncThunk<
    LikeListResponse,
    {
        photoId: string;
        offset: number;
        limit?: number;
    }
>('likes/get-photo-likes', async ({ photoId, limit, offset }) => {
    return api.getPhotoLikes({ id: photoId, offset: offset ?? 0, limit: limit ?? LIKES_FETCH_LIMIT });
});
